import { dateDiffMonths2 } from './dateUtil';

/**
 * Computes length-of-stay in months.
 * - Uses departure date when it's a valid "real" date (after Unix epoch), otherwise uses today's date.
 * - Returns a number, or null when data is insufficient.
 */
export const calculateLengthOfStayMonths = ({ admissionDate, departureDate, today = new Date() }) => {
  if (!admissionDate) return null;

  const endDate = departureDate && departureDate > new Date(0) ? departureDate : today;

  const months = dateDiffMonths2(endDate, admissionDate);
  if (months === '' || months === null || months === undefined) return null;

  return months;
};

/**
 * True when the student's `site` indicates Home Campus.
 */
export const isHomeCampusYouth = (site) => typeof site === 'string' && site.toLowerCase().includes('home campus');

/**
 * Calculates points for length of stay, using the rubric by scholarship version.
 *
 * Returns:
 *  - { points: number, notEligible: boolean, homeCampus: boolean }
 */
export const calculatePointsForLengthOfStay = ({ version, senior, today = new Date() }) => {
  const homeCampus = isHomeCampusYouth(senior?.site);

  // Version 2 rubric
  if (version === 2) {
    if (homeCampus) return { points: 10, notEligible: false, homeCampus: true };

    const months = calculateLengthOfStayMonths({
      admissionDate: senior?.admission_date,
      departureDate: senior?.departure_date,
      today,
    });

    // If we can't compute, default to 0 points and notEligible=false.
    if (months === null) return { points: 0, notEligible: false, homeCampus: false };

    if (months < 6) return { points: 0, notEligible: true, homeCampus: false };
    if (months < 12) return { points: 1, notEligible: false, homeCampus: false };
    if (months < 24) return { points: 5, notEligible: false, homeCampus: false };
    return { points: 10, notEligible: false, homeCampus: false };
  }

  // Legacy rubric (versions other than 2)
  const months = calculateLengthOfStayMonths({
    admissionDate: senior?.admission_date,
    departureDate: senior?.departure_date,
    today,
  });

  if (months === null) return { points: 0, notEligible: false, homeCampus };

  let points;
  if (months > 24) points = 20;
  else if (months > 12) points = 15;
  else if (months > 6) points = 10;
  else points = 5;

  return { points, notEligible: false, homeCampus };
};
